// extracted by mini-css-extract-plugin
export var phone = "_38-0";